import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

/**
 * Lesaffre brand color tokens extracted from the Lesaffre Design System.
 * Source: https://pages.lesaffre.app/design-system-front-0ca1f1/
 */
const brand = {
  primary50: '#f1f5fe',
  primary100: '#e1ebfd',
  primary200: '#afcafa',
  primary300: '#7da8f6',
  primary400: '#4b87f3',
  primary500: '#1966ef',
  primary600: '#0d4fc5',
  primary700: '#0a3b93',
  primary800: '#062357',
  primary900: '#020b1c',

  secondary50: '#f5f3f0',
  secondary100: '#f0eeea',
  secondary500: '#a3947a',
  secondary600: '#8a7b60',
  secondary700: '#584e3d',

  grey50: '#f5f5f5',
  grey100: '#e9eaeb',
  grey200: '#d5d7da',
  grey300: '#a4a7ae',
  grey400: '#717680',
  grey500: '#535862',
  grey700: '#252b37',
  grey900: '#0a0d12',
};

export const lesaffreTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: brand.primary700,
      light: brand.primary400,
      dark: brand.primary800,
    },
    secondary: {
      main: brand.secondary500,
    },
    error: {
      main: '#d92d20',
    },
    warning: {
      main: '#dc6803',
    },
    info: {
      main: '#2970ff',
    },
    success: {
      main: '#079455',
    },
    background: {
      default: brand.grey50,
      paper: '#ffffff',
    },
    navigation: {
      background: brand.primary800,
      indicator: brand.primary500,
      color: '#ffffff',
      selectedColor: '#ffffff',
      navItem: {
        hoverBackground: brand.primary700,
      },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({
      colors: [brand.primary700, brand.primary500],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: [brand.primary800, brand.primary700],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: [brand.primary700, brand.primary400],
      shape: shapes.round,
    }),
    other: genPageTheme({
      colors: [brand.primary700, brand.primary500],
      shape: shapes.wave,
    }),
  },
});
